/** Social posting API helpers + chunked media upload (4 MB chunks so videos get past proxy limits). */
import API_URL from '@/config/api';
import { wupload } from '@/components/website/api';

const CHUNK = 4 * 1024 * 1024;

export async function uploadSocialMedia(file, onProgress) {
  if (file.size <= CHUNK) {
    onProgress?.(50);
    const m = await wupload('/social/media', file);
    onProgress?.(100);
    return m;
  }
  const uploadId = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
  const total = Math.ceil(file.size / CHUNK);
  for (let i = 0; i < total; i += 1) {
    const fd = new FormData();
    fd.append('upload_id', uploadId);
    fd.append('index', String(i));
    fd.append('chunk', file.slice(i * CHUNK, (i + 1) * CHUNK));
    const r = await fetch(`${API_URL}/api/social/media/chunk`, { method: 'POST', credentials: 'include', body: fd });
    if (!r.ok) throw new Error(`Upload failed at part ${i + 1} of ${total}`);
    onProgress?.(Math.round(((i + 1) / total) * 90));
  }
  const r = await fetch(`${API_URL}/api/social/media/finalize`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ upload_id: uploadId, total, content_type: file.type || 'video/mp4' }) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || 'Upload failed');
  onProgress?.(100);
  return d;
}

export const STATUS_TONE = {
  scheduled: 'bg-sky-100 text-sky-800', publishing: 'bg-amber-100 text-amber-800', published: 'bg-emerald-100 text-emerald-800',
  partial: 'bg-orange-100 text-orange-800', failed: 'bg-rose-100 text-rose-800', cancelled: 'bg-slate-100 text-slate-600',
};
export const STATUS_LABEL = { scheduled: 'Scheduled', publishing: 'Posting…', published: 'Posted', partial: 'Partly posted', failed: 'Failed', cancelled: 'Cancelled' };

export function fmtWhen(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}
